var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Administration Laufnachweise")]),_c('RunsInvalidation',{attrs:{"page":parseInt(_vm.page) || 1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }